import { useRouteLoaderData } from 'react-router';

import type { Session } from '~/types/auth';
import type { RootLoaderData } from '~/types/root';

function isUser(user: any): user is Session {
  return user && typeof user === 'object' && typeof user.id === 'string';
}

export function useRootLoader(): RootLoaderData {
  const data = useRouteLoaderData('root');
  return data as RootLoaderData;
}

function useOptionalUser(): Session | undefined {
  const data = useRootLoader();
  if (!data || !isUser(data.user)) {
    return undefined;
  }
  return data.user;
}

export function useUser(): Session {
  const maybeUser = useOptionalUser();
  if (!maybeUser) {
    throw new Error(
      'No user found in root loader, but user is required by useUser. If user is optional, try useOptionalUser instead.'
    );
  }
  return maybeUser;
}
